// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export const CallIntelligenceService = {
    GetCallsViewByLocation(fn, req) {
        return fn(`/call-intelligence/v2/locations`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetCallsOverview(fn, req) {
        return fn(`/call-intelligence/v2/overview`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    OverviewStats(fn, req) {
        return fn(`/call-intelligence/v2/overview/stats`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ListCalls(fn, req) {
        return fn(`/call-intelligence/v2/calls`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetCallMetadata(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/call-intelligence/v2/call/${req["id"]}/metadata?${fm.renderURLSearchParams(req, ["id"])}`, { method: "GET" });
    },
    GetCallServiceQuality(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/call-intelligence/v2/call/${req["id"]}/service-quality?${fm.renderURLSearchParams(req, ["id"])}`, { method: "GET" });
    },
    GetLocationSiblings(fn, req) {
        return fn(`/call-intelligence/v2/location/siblings?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    SubmitFeedback(fn, req) {
        return fn(`/call-intelligence/v2/feedback`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetCallsCount(fn, req) {
        return fn(`/call-intelligence/v2/calls/stats`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ListFollowups(fn, req) {
        return fn(`/call-intelligence/v2/calls/followups`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Get tasks stats based on Call Filters - used for the Follow-ups Dashboard
     */
    GetCallFollowupsStats(fn, req) {
        return fn(`/call-intelligence/v2/calls/followups/stats`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ServiceQualityCallVolume(fn, req) {
        return fn(`/call-intelligence/v2/calls/service-quality/call-volume`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    DemoServiceQuality(fn, req) {
        return fn(`/call-intelligence/v2/demo/calls/service-quality`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
